/**
 * Angular Imports.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
/**
 * Interface Import.
 */
import { Profile, Speciality } from '../../interface/userprofile/userprofile';
import { EcSlideCards, Product, UserProfile } from './../../interface/editors-choice/editors-choice.model';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { DETAIL_ENTRY, DETAIL_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
/**
 * Services Imports.
 */
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { GetService } from '../../dataservices/get.service';
import { Subscription } from 'rxjs';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
/**
 * Constant Imports.
 */
import { ERROR_CODES, NUMBERS, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../constants/app.constants';
import { EVENT_NAME } from './../../analytics-event/analytics.constant';
import { DataStorageService } from '../../dataservices/data-storage.service';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Parent component for Editor-choice detail
 */
@Component({
  selector: 'app-editor-choice-detail',
  templateUrl: './editor-choice-detail.component.html',
  styleUrls: ['./editor-choice-detail.component.scss']
})
export class EditorChoiceDetailComponent implements OnInit, OnDestroy {

  /**
   * left profile import
   */
  profile_left_pic_image = {
    prflclass: 'box-size-100 text-center rounded-circle text-white d-table-cell align-middle',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'rounded-circle border box-size-100 post-pic',
    badge: { is_verified: 0, is_show: true },
    full_name: '',
    is_action: true,
    anonymous: '0'
  };
  /**
   * property for ec profile.
   */
  public profile: UserProfile;
  /**
   * property for ec_products.
   */
  public ec_products: EcSlideCards[];
  /**
   * property for product
   */
  public product: Product;
  /**
   * texthighlight for editor choice detail page.
   */
  public editorTextHighlight: string;
  /**
   * userProfileData for editor choice detail page.
   */
  public userProfileData: UserProfile;
  /**
   * Profile info for editor choice detail page.
   */
  public profileInfo: Profile;
  /**
   * key for userSpeciality for editor choice detail page.
   */
  public userSpeciality: Speciality[];
  /**
   * texthighlight for editor choice detail page.
   */
  public ecPostId: number;
  /**
   * Store error message text.
   */
  public errorMessage: string;
  /**
   * Api loading status.
   */
  public finished = false;
  /**
   * activemodule for profile section for editor choice detail page.
   */
  public activeModule: string;
  public sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Analyticsdata object.
   */
  public analyticsData: AnalyticsInterface;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  private startTime = 0;
  /**
   *  Necessary instance.
   */
  constructor(
    public dss: DataStorageService,
    private gerSer: GetService,
    public router: Router,
    public masterService: MasterserviceService,
    private route: ActivatedRoute,
    private fcs: FunCollectionService,
    private analyticSdk: Analytics,
  ) {
    this.masterService.profile_api_data.subscribe(data => {
      this.userProfileData = data;
    });
  }


  public allSubscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.startTime = new Date().getTime();
    const editorChoiceDetailSubs = this.route.params.subscribe(params => {
      this.ecPostId = params['id'];
      if (this.ecPostId) {
        this.getEditorChoiceDetail(this.ecPostId);
      }
    });
    this.allSubscriptions.add(editorChoiceDetailSubs);

    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
    /**
     * Set analytics data for analytics event.
     */
    const entryData: DETAIL_ENTRY = {
      entity_type :  PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,
      entity_code:   this.ecPostId,
      current_screen_name: SCREEN_NAME.EC_DETAIL,
      start_time: this.startTime = new Date().getTime(),
      source: this.fcs.currentScreename ? this.fcs.currentScreename : localStorage.getItem('triggerSource')
    }
    this.fcs.currentScreename = SCREEN_NAME.EC_DETAIL;
    this.analyticSdk.analyticService.DETAIL_ENTRY(entryData);
  }
  /**
   * Method for getting required data for ec detail page.
   */
  getEditorChoiceDetail(ecPostId): void {
    this.finished = true;
    const editorChoiceDetailSubs = this.gerSer.getEditorChoiceDetails(ecPostId).subscribe(resData => {
      this.finished = false;
      if (resData.status === NUMBERS.ONE) {
        this.editorTextHighlight = resData.data.editor_choice_details.highlight_text;
        this.ec_products = [...resData.data.editor_choice_details.product[0].ec_products];
        this.product = { ...resData.data.editor_choice_details.product[0] };
        this.profile = { ...resData.data.editor_choice_details.product[0].user_profile };
        this.profile_left_pic_image.prflpic = this.profile.profile_pic;
        this.profile_left_pic_image.prflcid = this.profile.custom_id;
        this.profile_left_pic_image.badge.is_verified = (this.profile.permission == 'all') ? 1 : 0;
      } else if (resData.status === NUMBERS.ZERO) {
        this.fcs.errorHandeler(resData);
        if (resData.error.code === ERROR_CODES.RESTRICTED_CONTENT_ERROR_CODE) {
          this.errorMessage = this.fcs.displayObj.data['pre_document_card'].description_text;
        } else {
          this.errorMessage = resData.error.msg;
        }
      }
    }, err => {
      this.finished = false;
      this.errorMessage = err.message;
    });
    this.allSubscriptions.add(editorChoiceDetailSubs);
  }
  /**
   * Unsubscribe subscribe data.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    if (this.allSubscriptions) {
      this.allSubscriptions.unsubscribe();
    }

    const dateObject = new Date();
    this.sessiontime.end_time = dateObject.getTime().toString();
    /**
     * Set analyics data on ngDestroy.
     */
    const exitData : DETAIL_EXIT =  {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.INSIGHT_COLLECTOR,
      entity_code: this.ecPostId,
      start_time: this.startTime,
      current_screen_name: SCREEN_NAME.EC_DETAIL,
      end_time: new Date().getTime()
    }
      this.analyticSdk.analyticService.DETAIL_EXIT(exitData);
  }
}
